module.exports = __webpack_public_path__ + "img/cloud_tool_relative.30a7815c.jpg";